import React from "react";
import {
  VictoryChart,
  VictoryLine,
  VictoryAxis,
  VictoryTooltip,
  VictoryVoronoiContainer,
  VictoryScatter,
  VictoryLegend,
} from "victory";

const FineGrainedChart = ({ chartData, xlabel, yLabel1, yLabel2 }) => {
  // combine both y1 and y2 values for domain
  const y1Values = chartData.map((d) => d.y1);
  const y2Values = chartData.map((d) => d.y2);
  const allY = [...y1Values, ...y2Values];

  const yMin = Math.min(...allY);
  const yMax = Math.max(...allY);

  const interval = Math.ceil((yMax - yMin) / 5);
  const yTicks = Array.from({ length: 6 }, (_, i) => yMin + i * interval);

  return (
    <VictoryChart
      domainPadding={{ x: 20, y: 20 }}
      padding={{ bottom: 40, top: 40, left: 70, right: 20 }}
      containerComponent={<VictoryVoronoiContainer />}
    >
      {/* Legend */}
      <VictoryLegend
        x={125}
        y={10}
        orientation="horizontal"
        gutter={20}
        style={{
          labels: { fill: "#104a5c", fontSize: 20 },
        }}
        data={[
          { name: yLabel1, symbol: { fill: "#8884d8", type: "circle" } },
          { name: yLabel2, symbol: { fill: "#82ca9d", type: "triangleUp" } },
        ]}
      />
      <VictoryAxis
        label={xlabel}
        style={{
          axisLabel: { fill: "#104a5c", padding: 10, fontSize: 20 },
          tickLabels: { display: "none" },
          ticks: { stroke: "black", size: 3 },
        }}
      />

      <VictoryAxis
        dependentAxis
        label="Value"
        tickValues={yTicks}
        style={{
          axisLabel: { fill: "#104a5c", padding: 40, fontSize: 20 },
          tickLabels: { fontSize: 10 },
          ticks: { stroke: "black", size: 3 },
        }}
      />

      {/* Series 1: y1 */}
      <VictoryLine
        data={chartData}
        x="x"
        y="y1"
        style={{ data: { stroke: "#8884d8", strokeWidth: 2 } }}
      />
      <VictoryScatter
        data={chartData}
        x="x"
        y="y1"
        size={4}
        symbol="circle"
        style={{ data: { fill: "#8884d8" } }}
        labels={({ datum }) => `x: ${datum.x}, ${yLabel1}: ${datum.y1}`}
        labelComponent={<VictoryTooltip style={{ fontSize: 10 }} />}
      />

      {/* Series 2: y2 */}
      <VictoryLine
        data={chartData}
        x="x"
        y="y2"
        style={{
          data: { stroke: "#82ca9d", strokeWidth: 2, strokeDasharray: "5,5" },
        }}
      />
      <VictoryScatter
        data={chartData}
        x="x"
        y="y2"
        size={4}
        symbol="triangleUp"
        style={{ data: { fill: "#82ca9d" } }}
        labels={({ datum }) => `x: ${datum.x}, ${yLabel2}$: ${datum.y2}`}
        labelComponent={<VictoryTooltip style={{ fontSize: 10 }} />}
      />
    </VictoryChart>
  );
};

export default FineGrainedChart;
